import React from 'react';
import DOMPurify from 'dompurify';
import { Card, Container, Dropdown, Form, DropdownButton, Select, Button,  Accordion, Row, Col } from 'react-bootstrap';
import { FaBook , FaBlog, FaSearch, FaEdit, FaCheck, FaTags, FaExpandArrowsAlt} from 'react-icons/fa';

import classes from './NewChapter.css';

const createMarkup = (html) => {
    return  {
      __html: DOMPurify.sanitize(html)
    }
  }

  
const newChapter = ( props ) => {
    let borderColor = props.complete ? "black" : "lightgray";
    var data = props.data;
    let statusIcon = props.complete ? <FaCheck /> : <FaEdit />;
    var bookList = props.bookList;
    return (

      <div className={classes.Blog} style={{border:'1px solid '+borderColor}}>
        <Form>
        

          <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
            <Form.Label column sm="2">
              Enter Chapter Name
            </Form.Label>
            <Col sm="6">
              <Form.Control type="text" id="cname" placeholder="Enter Chapter Name" />
            </Col>
            </Form.Group>


            <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
            <Form.Label column sm="2">
              Description
            </Form.Label>
            <Col sm="6">
              <Form.Control type="text" id="cdesc" placeholder="Enter Description" />
            </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword">
              <Col sm="10">
                <Button variant="secondary" size="lg" onClick={props.saveChapter}>Add Chapter</Button>
                &nbsp;&nbsp;<button className="btn btn-warning px-8" style={{fontSize:"15px"}} onClick={props.cancelHandler.bind()}>Cancel</button>
              </Col>
            </Form.Group>

        </Form>
      </div>



    );
};

export default newChapter;


// WEBPACK FOOTER //
// ./src/components/NewChapter/NewChapter.js